import React from 'react';

/**
 * Modal component for confirming unsaved changes.
 * This component is self-contained and styled with Tailwind CSS.
 * @param {object} props
 * @param {function} props.onYes - Function to call when "Yes" is clicked.
 * @param {function} props.onNo - Function to call when "No" is clicked.
 */
const UnsavedChangesModal = ({ onYes, onNo }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" aria-modal="true" role="dialog">
        <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6 text-center">
            <h3 className="text-lg font-semibold text-gray-900">Unsaved Changes</h3>
            <p className="mt-2 text-sm text-gray-600">Your changes are unsaved. Do you want to save it?</p>
            <div className="mt-6 flex justify-center gap-4">
                <button 
                    onClick={onYes} 
                    className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors"
                >
                    Yes
                </button>
                <button 
                    onClick={onNo} 
                    className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors"
                >
                    No
                </button>
            </div>
        </div>
    </div>
);

export default UnsavedChangesModal;
